<template>
  <div class="d-flex align-center flex-column">
    <v-img
      src="/images/logos/coro-icon.svg"
      width="100%"
      max-width="80"
      class="mb-7"
      contain
    ></v-img>
    <div
      class="headline5 mb-2"
      v-html="$t(`modals.${TutorialAction.TRIAL_HAS_STARTED}.trialStarted`)"
    ></div>
    <div
      class="body1 text-center"
      v-html="$t(`modals.${TutorialAction.TRIAL_HAS_STARTED}.demoModeHasFinished`)"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { TutorialAction } from "@/constants/tutorial.ts";
</script>
<style scoped></style>
